var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactUsTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4174 -0.00299072C10.9424 -0.00299072 0.834961 10.1045 0.834961 22.5794C0.834961 35.0544 10.9424 45.1619 23.4174 45.1619C35.8924 45.1619 45.9998 35.0544 45.9998 22.5794C45.9998 10.1045 35.8924 -0.00299072 23.4174 -0.00299072ZM34.5083 15.4678L30.8022 32.9328C30.529 34.1712 29.7915 34.4716 28.7625 33.8889L23.1169 29.7275L20.3943 32.35C20.0938 32.6505 19.8388 32.9054 19.256 32.9054L19.6567 27.1597L30.1193 17.7078C30.5746 17.3072 30.0191 17.0795 29.4181 17.4802L16.4879 25.6208L10.9151 23.8816C9.70403 23.4991 9.67671 22.6705 11.1701 22.0877L32.9421 13.6922C33.9528 13.3279 34.8361 13.938 34.5083 15.4678Z",
    fill: "#051C34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUsTwitter);
export default __webpack_public_path__ + "static/media/contactUsTwitter.65a51e507ff66388d2c580357b8413a1.svg";
export { ForwardRef as ReactComponent };